import { useEffect } from "react";
import { loadScript } from "./EmbedUtils";
import React from "react";


export function TikTokEmbed({tiktokURL}:{tiktokURL?:string}) {

    useEffect(() => {
        if (!loadScript("https://www.tiktok.com/embed.js", "tiktok-embed-script")) {
            let wind = window as any;
        const tiktoksOnPage = Array.from(document.querySelectorAll('blockquote.tiktok-embed'));
if (typeof wind.tiktokEmbed !== 'undefined' && tiktoksOnPage.length) {
  wind.tiktokEmbed.lib.render(tiktoksOnPage);
}
        }
    }, []);





   return (
       <>
           <blockquote
               className="tiktok-embed"
               cite={`https://www.tiktok.com/${tiktokURL}?refer=embed`}
               data-unique-id={tiktokURL?.substring(1)}
               data-embed-type="creator"
               style={{ maxWidth: "780px", minWidth: "288px" }}
           >
               <section>
                   <a target="_blank" href={`https://www.tiktok.com/${tiktokURL}?refer=creator_embed`}>{tiktokURL}</a>
               </section>
           </blockquote>

       </>
   );

}
